export function GroupNode() {
  return null;
}
